import { Component } from '@angular/core';

@Component({
  selector: 'ui-loading-spinner',
  imports: [],
  templateUrl: './loading-spinner.html',
  styleUrl: './loading-spinner.scss',
})
export class LoadingSpinner {
}
